<script>
import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    transcription: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    fileType: {
      type: String,
      default: 'audio', // 'audio' or 'image'
    },
  },
  emits: ['close', 'retry'],
  computed: {
    modalTitle() {
      return this.fileType === 'image' ? 'Descrição da Imagem' : 'Transcrição do Áudio';
    },
    hasContent() {
      return !this.isLoading && !this.hasError && this.transcription && this.transcription.trim().length > 0;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onRetry() {
      this.$emit('retry');
    },
  },
};
</script>

<template>
  <woot-modal
    modal-type="right-aligned"
    class="text-left"
    show
    :on-close="onClose"
  >
    <div class="content">
      <p>
        <b>{{ modalTitle }}</b>
      </p>
      <hr />

      <!-- Loading State -->
      <div v-if="isLoading" class="flex items-center gap-2">
        <Spinner size="small" />
        <p class="text-slate-600 dark:text-slate-400 mb-0">
          Carregando...
        </p>
      </div>

      <!-- Error State -->
      <div v-else-if="hasError" class="text-center py-4">
        <p class="text-red-600 dark:text-red-400 mb-3">
          Erro ao carregar a transcrição
        </p>
        <p class="text-sm text-slate-600 dark:text-slate-400 mb-4">
          Verifique sua conexão e tente novamente
        </p>
        <woot-button
          size="small"
          color-scheme="primary"
          @click="onRetry"
        >
          Tentar Novamente
        </woot-button>
      </div>

      <!-- Success State -->
      <div v-else-if="hasContent">
        <p v-dompurify-html="transcription" class="mb-0 whitespace-pre-wrap" />
      </div>

      <!-- Empty State -->
      <div v-else class="text-center py-4">
        <p class="text-slate-600 dark:text-slate-400 mb-0">
          Nenhum conteúdo disponível
        </p>
      </div>
    </div>
  </woot-modal>
</template>
